package components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.value
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLInputElement

@Composable
fun InputSection(title: String) {
    Div({ classes("input-section") }) {
        Text(title)
    }
}

@Composable
fun NumberField(
    label: String,
    suffix: String,
    helpText: String,
    currentValue: String,
    error: String?,
    onChange: (String) -> Unit,
) {
    Div({ classes("field") }) {
        Span({ classes("field-label") }) { Text(label) }
        P({ classes("field-help") }) { Text(helpText) }
        Div({ classes("input-row") }) {
            Input(InputType.Text) {
                value(currentValue)
                attr("value", currentValue)
                attr("aria-label", label)
                attr("inputmode", "decimal")
                placeholder("0")
                onInput { event ->
                    onChange(event.value)
                }
                onChange { event ->
                    onChange(event.value)
                }
                onKeyUp { event ->
                    onChange(event.target.unsafeCast<HTMLInputElement>().value)
                }
            }
            Span({ classes("suffix") }) { Text(suffix) }
        }
        if (error != null) {
            P({ classes("field-error") }) { Text(error) }
        }
    }
}

@Composable
fun TextField(label: String, placeholderText: String, currentValue: String, onChange: (String) -> Unit) {
    Div({ classes("field") }) {
        Span({ classes("field-label") }) { Text(label) }
        Div({ classes("input-row", "text-input-row") }) {
            Input(InputType.Text) {
                value(currentValue)
                attr("value", currentValue)
                attr("aria-label", label)
                placeholder(placeholderText)
                onInput { event -> onChange(event.value) }
                onChange { event -> onChange(event.value) }
                onKeyUp { event -> onChange(event.target.unsafeCast<HTMLInputElement>().value) }
            }
        }
    }
}

@Composable
fun Metric(label: String, value: Any) {
    Div({ classes("metric") }) {
        Span({ classes("summary-label") }) { Text(label) }
        Span({ classes("metric-value") }) { Text(value.toString()) }
    }
}
